import { render, staticRenderFns } from "./ScoreTriggerOptions.vue?vue&type=template&id=6c67cf96&"
import script from "./ScoreTriggerOptions.vue?vue&type=script&lang=ts&"
export * from "./ScoreTriggerOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports